import React, { useState, useEffect } from 'react';
import { withRouter, Link } from 'react-router-dom';
import queryString from 'query-string';
import StyleFabricListComponent from './StyleFabricListComponent';

import * as ProductService from '../../../services/Product.service';
import * as AppData from '../../../data/App.data';
import { init } from '../../../data/App.data';

const StyleFabricListContainer = props => {

    const [list, setList] = useState([]);
    const [category, setCategory] = useState(null);

    useEffect(_ => {
        async function init(categoryCode) {
            const list = await ProductService.getList(categoryCode);
            console.log(list);
            setList(list);
        }
        let params = queryString.parse(props.location.search);
        if (params['categoryCode']) {
            // console.log(AppData.getChildCategoryList());
            // setCategory(AppData.getChildCategoryList()[params['categoryCode']]);
            const category = AppData.getCategory(params['categoryCode']);
            setCategory(category);
            console.log(category);
            init(params['categoryCode']);
        }

        return (_ => {

        });
    }, [props])

    return (
        <StyleFabricListComponent
            category={category}
            list={list} />
    )
}

export default withRouter(StyleFabricListContainer);